import {Model} from "@vuex-orm/core";
import Tool from "./Tool";
import WorkOrder from "./WorkOrder";

export default class ToolProcess extends Model {
  static entity = 'toolprocesses';

  static $fetch() {
    return this.api().get('ToolProcesses/')
  }
  static $fetchByTool(toolid) {
    return this.api().get(`ToolProcesses/?tool=${toolid}&completed=true&migrated=false`)
  }
  static $get (id) {
    return this.api().get(`ToolProcesses/${id}/`)
  }
  static $post (data) {
    return this.api().post(`ToolProcesses/`, data)
  }
  static $put (id, data) {
    return this.api().put(`ToolProcesses/${id}/`, data)
  }
  static $patch (id, data) {
    return this.api().patch(`ToolProcesses/${id}/`, data)
  }

  static fields() {
    return {
      id: this.attr(null),
      tool: this.belongsTo(Tool, 'tool_id'),
      tool_id: this.attr(null),
      workorder: this.belongsTo(WorkOrder, 'workorder_id'),
      workorder_id: this.attr(null),
      in_que: this.boolean(true),
      in_process: this.boolean(false),
      in_que_start: this.string(""),
      in_que_end: this.string(""),
      in_process_start: this.string(""),
      in_process_end: this.string(""),
      priority: this.number(0),
      completed: this.boolean(false),
      migrated: this.boolean(false),
      que_duration: this.string(0),
      process_duration: this.string(0),
      duration_estimate: this.number(0)
    }
  }

  toCreatePayload() {
    return {
      tool: this.tool_id,
      workorder: this.workorder_id,
      duration_estimate: this.duration_estimate
    };
  }

  prettyTimes() {
    let que_start = new Date(this.in_que_start).toLocaleString("en-US", {timeZone: "America/Denver"});
    let process_start = new Date(this.in_process_start).toLocaleString("en-US", {timeZone: "America/Denver"});
    let process_end = new Date(this.in_process_end).toLocaleString("en-US", {timeZone: "America/Denver"});
    return { que_start, process_end, process_start }
  }

}
